<div [ngClass]="labelTextTransformNone ? 'input-field-name-none': 'input-field-name'" *ngIf="labelName && showLabelName">
  {{ labelName }}
  <span *ngIf="tooltiptxt" [ngbTooltip]=tooltiptxt placement="right" >
    <em
    class="fa fa-info-circle info-icon"
  ></em></span>
  <span class="optional" *ngIf="!isRequiredField && showOptionalLabel">({{OPTIONAL}})</span>
</div>
<div *ngIf="readOnlyMode"  class="readOnly">{{inputFormControl.value}}</div>
<textarea
  *ngIf="!readOnlyMode"
  [ngClass]="getClasses()"
  [formControl]="inputFormControl"
  rows="2"
></textarea>
<div *ngIf="showCommentIcon" class="comment-icon">
  <app-button [type]="(commentObject && commentObject.value && commentObject.value.length) ? 'commented-icon' : 'comment-icon' " (btnClick)="clickComment()" [disable]="disableComments"></app-button>
</div>
<div
  [ngClass]="labelTextTransformNone ? 'error-none': 'error'"
  *ngIf="inputFormControl && !readOnlyMode && labelName && (submitted || inputFormControl.touched) && inputFormControl.errors"
>
  <div *ngIf="inputFormControl.errors.required">
    {{ labelName }} is required
  </div>
  <div *ngIf="inputFormControl.errors.maxlength">
    {{ labelName }} should not exceed 300 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax100">
    {{ labelName }} should not contain more than 100 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax200">
    {{ labelName }} should not contain more than 200 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax300">
    {{ labelName }} should not contain more than 300 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax500">
    {{ labelName }} should not contain more than 500 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax1000">
    {{ labelName }} should not contain more than 1000 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax2000">
    {{ labelName }} should not contain more than 2000 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax3000">
    {{ labelName }} should not contain more than 3000 characters.
  </div>
  <div *ngIf="inputFormControl.errors.invalidTextMax4000">
    {{ labelName }} should not contain more than 4000 characters.
  </div>
  <div *ngIf="inputFormControl.errors.htmlTagError">
    {{ labelName }} do not allow HTML TAGS.
  </div>

</div>
